<template>
	<q-carousel
		swipeable
		animated
		keep-alive
		v-model="slide_teste"
		ref="carousel"
		v-model:fullscreen="fullscreen"
		:height="$q.platform.is.mobile ? '70vh' : '80vh'"
	>
		<q-carousel-slide :name="1">
			<img :src="getSlide" style="width: 100%" />
		</q-carousel-slide>

		<template v-slot:control>
			<q-carousel-control position="bottom-right" :offset="[35, 10]" class="q-gutter-xs">
				<q-btn
					push
					round
					dense
					color="secondary"
					text-color="white"
					icon="fal fa-chevron-left"
					@click="goLeft()"
					:disable="disableButtonPrevious"
				/>
				<q-btn
					push
					round
					dense
					color="secondary"
					text-color="white"
					icon="fal fa-chevron-right"
					@click="goRight()"
					:disable="disableButtonNext"
				/>
				<q-btn
					push
					round
					dense
					color="secondary"
					text-color="white"
					:icon="fullscreen ? 'fal fa-compress' : 'fal fa-expand'"
					@click="handleFullScreen"
				/>
			</q-carousel-control>
		</template>
	</q-carousel>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'PdfPlayer',

	props: ['activity'],

	data() {
		return {
			container_style: '',
			controller_style: '',
			current_slide: 0,
			id_course: '',
			id_trail: '',
			is_full_screen: false,
			loading: false,
			player_style: '',
			slide: {},
			slide_style: '',
			slides: [],
			slide_teste: 1,
			fullscreen: false,
			total_slides_by_5: 0,
			user_is_leaving: false,
		}
	},

	computed: {
		...mapGetters({
			activities: 'activities/activities',
			hierarchy_order: 'activities/hierarchy_order',
			id: 'activities/id',
		}),

		getSlide() {
			return this.slide ? this.slide : ''
		},

		disableButtonPrevious() {
			if (this.loading) return true
			return this.current_slide === 1 ? true : false
		},

		disableButtonNext() {
			if (this.loading) return true
			return this.current_slide == this.slides.length ? true : false
		},

		shouldSaveProgress() {
			if (
				this.user_is_leaving ||
				this.total_slides_by_5 === 0 ||
				this.current_slide === this.total_slides_by_5 ||
				this.current_slide === this.total_slides_by_5 * 2 ||
				this.current_slide === this.total_slides_by_5 * 3 ||
				this.current_slide === this.total_slides_by_5 * 4 ||
				this.current_slide === this.activity.total_slides
			)
				return true
			else return false
		},
	},

	methods: {
		handleFullScreen() {
			this.fullscreen = !this.fullscreen
			const img = document.getElementsByClassName('fullscreen')
			console.log(img)
		},

		getSlides() {
			this.slides = this.activity.resource.map((e) => ({ ...e, image: e.file }))
			this.current_slide = this.activity.current_slide === 0 ? 1 : this.activity.current_slide
			this.fileAuthenticatedAndSavePosition(this.slides[this.current_slide - 1].image)
		},

		sendPosition() {
			if (this.shouldSaveProgress) {
				this.loading = true
				let fd = new FormData()
				fd.append('current_slide', this.current_slide)
				fd.append('total_slides', this.slides.length)
				fd.append('id_group_training_module', this.activity.type_id)

				let url = ''
				if (this.id_trail === '')
					url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
				else
					url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`

				this.$axios
					.post(url, fd)
					.then((response) => {
						this.updatePosition(response.data.total_slides)
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.loading = false
					})
			} else this.updatePosition(this.activity.total_slides)
		},

		updatePosition(total_slides) {
			let activities = JSON.parse(JSON.stringify(this.activities))

			let obj = activities.find((obj) => {
				return obj.hierarchy_order == this.activity.hierarchy_order
			})
			if (obj) {
				obj.current_slide = this.current_slide

				if (this.current_slide == total_slides) {
					if (!obj.user_watch) {
						obj.user_watch = true
						this.$store.dispatch('activities/SET_ACTIVITIES', [activities])
						this.$store.dispatch('activities/SET_ACTIVITY_DATA', [
							this.activity,
							{ user_watch: true },
						])
						setTimeout(() => {
							this.$emit('finish')
						}, 500)
					}
				} else this.$store.dispatch('activities/SET_ACTIVITIES', [activities])
			}
		},

		userHasSwiped(obj) {
			if (obj.direction === 'left') this.goRight()
			else if (obj.direction === 'right') this.goLeft()
		},

		goLeft() {
			if (this.current_slide > 0) {
				this.current_slide = this.current_slide - 1
				this.fileAuthenticatedAndSavePosition(this.slides[this.current_slide - 1].image)
			}
		},

		goRight() {
			if (this.current_slide < this.slides.length) {
				this.current_slide = this.current_slide + 1
				this.fileAuthenticatedAndSavePosition(this.slides[this.current_slide - 1].image)
			}
		},

		toggleFullscreen(e) {
			const target = e.target.closest('.container')
			if (!this.is_full_screen) {
				this.is_full_screen = true

				this.$q.fullscreen
					.toggle(target)
					.then(() => {
						target.style = 'width: 100%; top: 0; left: 0; transform: none; height: 100vh;'

						this.container_style =
							'display: block; z-index: 9999; position: fixed; top: 0; height: auto; left: 0; bottom: 0; right: 0; overflow: auto;'

						if (this.$q.platform.is.mobile) {
							this.controller_style = 'position: absolute; width: 100%; height: 9vh; padding: 0px;'
							this.player_style =
								'width: auto; display: flex; height: 91vh; justify-content: center;'
							this.slide_style = 'width: auto; height: 91vh;'
						} else {
							this.controller_style =
								'position: absolute; width: 100%; height: 40px; padding: 0px; bottom: 0;'
							this.player_style = 'width: 100vw; display: flex; justify-content: center;'
							this.slide_style = 'width: 100vw; height: calc(95vh - 40px);'
						}
					})
					.catch((err) => {
						alert(err)
					})
			} else {
				target.style = ''

				this.$q.fullscreen
					.exit()
					.then(() => {
						this.is_full_screen = false
						this.container_style = ''
						this.player_style = ''
						this.slide_style = ''
						this.controller_style = ''
					})
					.catch((err) => {
						alert(err)
					})
			}
		},

		fileAuthenticatedAndSavePosition(url) {
			this.loading = true
			let data = {
				file_url: url,
			}

			this.$axios
				.post('/utils/presigned_url/', data)
				.then((response) => {
					this.slide = response.data.file_url
					this.sendPosition()
					this.loading = false
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.image_picker = false
					this.loading = false
				})
		},
	},

	created() {
		if (this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
		if (this.$route.params.id) this.id_course = this.$route.params.id

		if (!this.activity.total_slides || this.activity.total_slides <= 5) this.total_slides_by_5 = 0
		if (this.activity.total_slides > 5)
			this.total_slides_by_5 = Math.ceil(this.activity.total_slides / 5)

		document.addEventListener('keydown', (e) => {
			switch (e.keyCode) {
				case 37:
					this.goLeft()
					break
				case 39:
					this.goRight()
					break
			}
		})

		this.getSlides()
	},

	beforeUnmount() {
		this.user_is_leaving = true
		this.sendPosition()
	},
}
</script>

<style lang="scss" scoped>
.player {
	width: 100%;
}
.slide {
	width: 100%;
	height: auto;
}
.controller {
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	height: 40px;
	position: relative;
}
.fullscreen {
	position: absolute;
	right: 0;
}
.fullscreen img {
	min-height: 100%;
}
</style>
